import React from "react";
import {Paper, useTheme} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles(theme => {
    return {
        root: {
            padding: theme.spacing(2),
            display:"flex",
            justifyContent:"center",
            flexDirection: "column"
        }
    }
})

export default function(props){
    const styles = useStyles(useTheme())
    return <Paper className={styles.root} {...props}/>
}
